const uz = {
    meta: {
        title: "Web sayt nima va kimga kerak — narx va qaytim | Innobek",
        description:
            "Web sayt nima, nimalardan tashkil topadi va kimga kerak. Sayt narxi 4–45 mln so'm, qaytim hisobi, saytsizlik narxi va sayt kerak bo'lmagan holatlar.",
        keywords: [
            "web sayt",
            "veb-sayt nima",
            "sayt yaratish narxi",
            "sayt nima uchun kerak",
            "sayt qancha turadi",
            "domen va hosting",
            "korporativ sayt",
        ],
    },
    h1: "Web sayt: biznesga nima beradi, qancha turadi va qachon o'zini oqlaydi",
    lead:
        "Sayt — bu «bo'lsa yaxshi» deb olinadigan narsa emas, balki xarajati va qaytimi hisoblanadigan aktiv. Bu maqolada sayt nimadan tashkil topishini, O'zbekistonda qancha turishini va qaysi holatda umuman kerak emasligini raqamlar bilan ko'rib chiqamiz.",
    category: "Veb-saytlar",
    readingTime: "10 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Har hafta bizga «sayt kerakmi yoki Instagram yetadimi?» degan savol bilan murojaat qilishadi. To'g'ri javob har doim ham «ha» emas. Ba'zi bizneslarga sayt birinchi oyidanoq pul keltiradi, ba'zilariga esa u shunchaki 9 million so'mlik bezak bo'lib qoladi. Farq nimada — quyida shuni ochamiz.",
        },

        { type: "h2", text: "Web sayt nima va u nimalardan tashkil topadi?" },
        {
            type: "p",
            text:
                "Web sayt — bitta tashkilot yoki shaxsga tegishli, mazmunan o'zaro bog'langan veb-sahifalar majmui. Sahifada matn, rasm, video, forma va hisob-kitob moduli bo'lishi mumkin. Texnik jihatdan sayt — bu internetga ulangan serverda turgan fayllar to'plami va ularni brauzerga uzatuvchi dastur.",
        },
        {
            type: "p",
            text:
                "Biznes egasi uchun esa muhimi boshqa: sayt uchta ijaraga olinadigan qismdan va bitta sotib olinadigan qismdan iborat. Ijaraga olinadiganlari — domen, hosting va SSL sertifikati. Sotib olinadigani — saytning o'zi, ya'ni dizayn va kod.",
        },
        {
            type: "list",
            items: [
                "Domen — saytning manzili, masalan innobek.uz. Bu yerda uz — domen zonasi. .uz zonasi 1995-yildan beri UZINFOCOM tomonidan boshqariladi va cctld.uz orqali ro'yxatdan o'tkaziladi.",
                "Hosting (server) — sayt fayllari joylashgan, internetga doimiy ulangan kompyuter. Sayt shu yerda «yashaydi».",
                "SSL sertifikati — brauzerdagi qulf belgisi. Usiz Google saytni «xavfsiz emas» deb belgilaydi va tashrif buyuruvchi formani to'ldirmaydi.",
                "Frontend — foydalanuvchi ko'radigan qism: dizayn, matn, tugmalar, mobil moslashuv.",
                "Admin panel — siz dasturchisiz matn, narx va rasmni o'zgartiradigan boshqaruv paneli.",
            ],
        },
        { type: "image", image: 3 },
        {
            type: "p",
            text:
                "Shu beshtadan biri yetishmasa, sayt to'liq ishlamaydi. Admin panelsiz sayt har bir vergul uchun dasturchiga bog'liq bo'lib qoladi. Mobil moslashuvsiz sayt esa bugun mavjud bo'lmagan bilan barobar — Google 2024-yildan beri barcha saytlarni mobil versiyasi bo'yicha indekslaydi.",
        },

        { type: "h2", text: "Instagram bor-ku, sayt nega kerak?" },
        {
            type: "p",
            text:
                "Bu eng ko'p beriladigan savol va unga halol javob shu: ijtimoiy tarmoq va sayt bir-birini almashtirmaydi, ular turli vazifani bajaradi. Instagram — bu ijara qilingan auditoriya. Akkaunt bloklansa yoki algoritm o'zgarsa, siz bir kechada butun kanalni yo'qotasiz va buni hech kimdan talab qila olmaysiz.",
        },
        {
            type: "p",
            text:
                "Sayt — sizga tegishli aktiv. U qidiruv tizimidan trafik oladi, ya'ni odam «Toshkentda ombor uskunalari» deb qidirganda sizni topadi. Instagram bunday so'rovga chiqmaydi. Bundan tashqari sayt korporativ mijoz uchun ishonch mezoni: yirik kompaniya tenderga Instagram havolasini qabul qilmaydi.",
        },
        {
            type: "p",
            text:
                "Marketpleys ham shunday — Uzum yoki boshqa maydonchada sotish oson boshlanadi, lekin har sotuvdan ulush ketadi va mijoz bazasi sizniki emas, maydonchaniki bo'lib qoladi. Amaliyotimizda eng barqaror model — uchalasi birga: sayt asos, ijtimoiy tarmoq qiziqish uyg'otish uchun, marketpleys qo'shimcha kanal sifatida.",
        },

        { type: "h2", text: "Sayt biznesga aniq nima beradi?" },
        {
            type: "p",
            text:
                "Umumiy gaplarni chetga surib, sayt bajaradigan beshta o'lchanadigan vazifani sanaymiz. Har birining yonida uni qanday tekshirish mumkinligini ham ko'rsatamiz — chunki o'lchanmaydigan foyda foyda emas.",
        },
        {
            type: "list",
            items: [
                "Qidiruvdan ariza olib keladi. Bu Google Analytics va forma jo'natmalari soni orqali o'lchanadi. Asosiy ko'rsatkich — bitta arizaning tannarxi.",
                "Sotuv bo'limining vaqtini tejaydi. Narx, yetkazib berish shartlari va texnik xususiyatlar saytda yozilgan bo'lsa, menejer bir xil savolga kuniga o'n marta javob bermaydi.",
                "Ishonch hosil qiladi. Rekvizitlar, litsenziya, bajarilgan ishlar va real mijoz sharhlari — bularning hammasi shartnomagacha bo'lgan shubhani kamaytiradi.",
                "Reklamani arzonlashtiradi. Google Ads va Instagram reklamasini to'g'ri qurilgan sahifaga yo'naltirsangiz, konversiya o'sadi va bitta mijoz narxi tushadi.",
                "Ichki ishni yengillashtiradi. Hujjatlar, narx ro'yxati, bo'sh ish o'rinlari va hisobotlar bitta manzilda turadi — xodim ularni dunyoning istalgan joyidan oladi.",
            ],
        },
        {
            type: "p",
            text:
                "Bu ro'yxatdagi hech bir band avtomatik ishlamaydi. Sayt ochilgan kuniyoq ariza kelmaydi — uni odamlar topishi kerak. Shuning uchun keyingi bo'limda narxni faqat ishlab chiqish emas, balki ishga tushirish bilan birga hisoblaymiz.",
        },

        { type: "h2", text: "Sayt yaratish qancha turadi?" },
        {
            type: "p",
            text:
                "Narx sayt turiga bog'liq, sahifalar soniga emas. Quyidagi jadvalda Innobek narxlari va o'rtacha muddat keltirilgan. Bular boshlang'ich oraliq: yakuniy summa integratsiyalar, kontent hajmi va til versiyalariga qarab bepul konsultatsiyadan keyin tasdiqlanadi.",
        },
        {
            type: "table",
            head: ["Sayt turi", "Narxi (so'm)", "Muddat", "Kimga mos"],
            rows: [
                ["Landing page", "4 000 000 dan", "5–10 ish kuni", "Bitta mahsulot, reklama oqimi, tezkor test"],
                ["Vizitka sayt", "5 000 000 dan", "7–12 ish kuni", "Kichik biznes, mutaxassis, xizmat ko'rsatuvchi"],
                ["Korporativ sayt", "9 000 000 dan", "12–35 ish kuni", "Ishlab chiqarish, distribyutor, xizmat kompaniyasi"],
                ["Internet-do'kon", "16 000 000 dan", "20–60 ish kuni", "Tovarni onlayn sotish, savat va to'lov"],
                ["Murakkab platforma", "45 000 000 dan", "kelishuv asosida", "Shaxsiy kabinet, filial tizimi, 1C integratsiyasi"],
            ],
        },
        {
            type: "p",
            text:
                "Narxga kirmaydigan narsalarni alohida aytish kerak, chunki aynan shu yerda kutilmagan xarajat paydo bo'ladi. Domen va hosting to'lovi provayderga to'g'ridan-to'g'ri to'lanadi — oddiy sayt uchun yiliga taxminan 400 000 – 1 200 000 so'm, yuklamasi katta do'kon uchun 1,5–3 mln so'm. Professional fotosurat, matn yozish va reklama byudjeti ham alohida hisoblanadi.",
        },
        {
            type: "callout",
            text:
                "Amaliy qoida: sayt byudjetini rejalashtirganda ishlab chiqish narxining ustiga yana 30–50% qo'shing — bu kontent, fotosurat va birinchi olti oylik reklama uchun. Sayt bor, lekin uni hech kim ko'rmaydigan holat eng ko'p uchraydigan xato.",
        },

        { type: "h2", text: "Sayt qachon o'zini oqlaydi?" },
        {
            type: "p",
            text:
                "Qaytimni hisoblash uchun sizga to'rtta raqam kerak: oylik tashriflar soni, ariza konversiyasi, arizadan shartnomaga o'tish ulushi va o'rtacha chekdagi marjangiz. Quyida o'rtacha B2B xizmat kompaniyasi misolida hisob keltiramiz — o'z raqamlaringizni qo'yib chiqing.",
        },
        { type: "image", image: 1 },
        {
            type: "ol",
            items: [
                "Oyiga 900 ta tashrif — bu SEO va kontekst reklama olti oy ishlagandan keyingi real ko'rsatkich.",
                "Saytdagi konversiya 3% — 27 ta ariza. Yaxshi qurilgan sayt uchun 2–4% normal oraliq.",
                "Arizadan shartnomaga o'tish 20% — 5 ta mijoz.",
                "O'rtacha chek 6 000 000 so'm, marja 30% — bitta mijozdan 1 800 000 so'm sof foyda.",
                "Oylik sof foyda: 5 × 1 800 000 = 9 000 000 so'm.",
            ],
        },
        {
            type: "p",
            text:
                "Endi xarajat tomonini qo'shamiz. Korporativ sayt 9 mln so'm, olti oylik SEO oyiga 6 mln so'mdan, ya'ni birinchi yilda taxminan 45 mln so'm. Trafik nolinchi oydan boshlanmaydi: birinchi uch oy deyarli ariza yo'q, keyin o'sib boradi. Shu sababli halol javob — bunday model odatda 8–14 oyda nolga chiqadi, ikkinchi yildan boshlab foyda keltiradi.",
        },
        {
            type: "p",
            text:
                "Agar sizning o'rtacha chekingiz 500 000 so'm bo'lsa, xuddi shu hisob butunlay boshqacha chiqadi — sizga arizalar hajmi kerak, ya'ni SEO emas, avval reklama va konversiyaga ishlash kerak. Shuning uchun biz hech qachon «sayt 3 oyda o'zini oqlaydi» degan universal va'dani bermaymiz: bu raqam sizning marjangizga bog'liq.",
        },

        { type: "h2", text: "Saytsiz qolishning narxi qancha?" },
        {
            type: "p",
            text:
                "Hech narsa qilmaslik ham pul turadi, faqat bu xarajat hisobda ko'rinmaydi. Uni taxminiy hisoblash mumkin. Faraz qiling, sizning sohangizda oyiga 400 kishi Google'da mos so'rov bilan qidiradi va shundan 4 foizi murojaat qiladi — bu 16 ta ariza. Ularning hammasi bugun raqobatchiga ketmoqda.",
        },
        {
            type: "p",
            text:
                "Yuqoridagi marja bilan (1 800 000 so'm) va 20% shartnoma ulushi bilan bu oyiga 3 ta mijoz, ya'ni 5 400 000 so'm qo'lga kirmagan foyda. Yiliga — 64 mln so'mdan ortiq. Sayt narxi bu raqam oldida kichik ko'rinadi, lekin shartni unutmang: bu trafik siz uchun avtomatik kelmaydi, uni qo'lga kiritish kerak.",
        },
        {
            type: "p",
            text:
                "Ikkinchi yashirin xarajat — vaqt. Menejer kuniga ikki soatini bir xil savollarga javob berishga sarflasa, oyiga 40 soat ketadi. Bu deyarli bir hafta ish vaqti, uni saytdagi to'g'ri yozilgan narx va shartlar bo'limi qaytarib beradi.",
        },

        { type: "h2", text: "Sayt qachon sizga kerak emas?" },
        {
            type: "p",
            text:
                "Bu bo'limni yozish biz uchun ham foydali emas, lekin usiz maqola halol bo'lmaydi. Quyidagi holatlarda sayt eng yaxshi investitsiya emas va biz buni mijozga ochiq aytamiz.",
        },
        {
            type: "list",
            items: [
                "Mahsulotingiz hali tasdiqlanmagan. Birinchi 10 ta sotuvni qo'lda, Telegram yoki Instagram orqali qiling. Sayt gipotezani tekshirmaydi, u tasdiqlangan gipotezani kengaytiradi.",
                "Butun sotuvingiz bitta yopiq kanalga bog'langan. Davlat tenderi yoki bitta yirik distribyutor orqali ishlasangiz, sizga sayt emas, rasmiy hujjatlar va rekvizitlari bor oddiy vizitka sahifasi yetadi.",
                "Sayt ochilgandan keyin unga byudjet yo'q. Reklama va SEO uchun mablag' rejalashtirilmagan bo'lsa, sayt bir yil turadi va hech kim kirmaydi.",
                "Sizda kontent yo'q va uni tayyorlashga odam ajratmaysiz. Bo'sh matn va stok rasm bilan to'ldirilgan sayt ishonchni oshirmaydi, aksincha tushiradi.",
                "Sizga sayt emas, ichki tizim kerak. Agar asosiy og'riq buyurtmalarni hisobga olish bo'lsa, avval CRM qiling, sayt keyin keladi.",
            ],
        },
        {
            type: "p",
            text:
                "Yana bir kamchilikni ochiq aytamiz: sayt tez natija bermaydi. Kontekst reklama bir hafta ichida ariza keltiradi, organik trafik esa 4–6 oy talab qiladi. Agar sizga natija shu oyda kerak bo'lsa, byudjetning katta qismini reklamaga ajrating, saytni esa shu reklama tushadigan sahifa sifatida quring.",
        },

        { type: "h2", text: "Sayt ishga tushgandan keyin nima bo'ladi?" },
        {
            type: "p",
            text:
                "Topshirish — bu boshlanish, tugash emas. Birinchi oyda sayt Google'ga indekslanadi, Analytics va Search Console ulanadi, forma arizalari Telegram yoki CRM'ga tushishi tekshiriladi. Shundan keyingina real ma'lumot yig'ila boshlaydi.",
        },
        { type: "image", image: 2 },
        {
            type: "list",
            items: [
                "Texnik kuzatuv: sayt tushib qolmasligi, zaxira nusxa, SSL va yangilanishlar.",
                "Tezlik: LCP 2,5 soniyagacha, CLS 0,1 dan past — bular Google'ning ochiq e'lon qilingan Core Web Vitals chegaralari.",
                "Kontent: xizmat sahifalari va maqolalarni to'ldirib borish, aks holda o'sish to'xtaydi.",
                "Tahlil: qaysi sahifadan ariza kelyapti, qaysi sahifadan odam chiqib ketyapti.",
            ],
        },
        {
            type: "p",
            text:
                "Innobek'da olti oylik qo'llab-quvvatlash sayt narxiga kiradi. Undan keyin xohlasangiz, oylik shartnoma tuzamiz; shartnomasiz ham murojaat qilish mumkin, bu holda ish soatbay hisoblanadi. Muhim jihat: kod va domen sizga tegishli bo'ladi, biz ularni o'zimizda ushlab qolmaymiz.",
        },

        { type: "h2", text: "Qayerdan boshlash kerak?" },
        {
            type: "ol",
            items: [
                "Sayt qaysi bitta vazifani hal qilishini yozing: ariza olish, ishonch berish yoki onlayn sotish. Uchtasini bitta byudjetda qilishga urinish natijani suyultiradi.",
                "O'rtacha chek va marjangizni hisoblang — shu ikki raqamsiz qaytimni hisoblab bo'lmaydi.",
                "Sayt turini tanlang. Ikkilansangiz, kichikroqdan boshlang: vizitka saytni keyinroq korporativgacha kengaytirish mumkin.",
                "Kontentni oldindan tayyorlang: xizmatlar ro'yxati, narxlar, bajarilgan ishlar, jamoa fotosurati.",
                "Ishga tushirishdan keyingi olti oyga reklama yoki SEO byudjetini rejalashtiring.",
            ],
        },
        {
            type: "quote",
            text:
                "Sayt savolga javob bermaydi — u savol beradigan odamni topib keladi. Qolgani sizning sotuv bo'limingizga bog'liq.",
        },
    ],

    faq: [
        {
            q: "Sayt yaratish O'zbekistonda qancha turadi?",
            a: "Innobek'da landing page 4 000 000 so'mdan, vizitka sayt 5 000 000 so'mdan, korporativ sayt 9 000 000 so'mdan, internet-do'kon esa 16 000 000 so'mdan boshlanadi. Shaxsiy kabinet, filial tizimi yoki 1C integratsiyasi kerak bo'lsa, narx odatda 45 mln so'mdan oshadi. Yakuniy summa sahifalar soni, integratsiyalar va til versiyalariga qarab bepul konsultatsiyadan keyin tasdiqlanadi.",
        },
        {
            q: "Domen va hosting uchun yiliga qancha to'lanadi?",
            a: "Oddiy vizitka yoki korporativ sayt uchun domen va hosting birgalikda yiliga taxminan 400 000 – 1 200 000 so'm turadi. Yuklamasi katta internet-do'kon uchun bu summa 1,5–3 mln so'mga chiqadi. To'lov provayderga to'g'ridan-to'g'ri qilinadi va sayt narxiga kirmaydi. Domen sizning nomingizga rasmiylashtiriladi — biz uni o'zimizda saqlab qolmaymiz.",
        },
        {
            q: "Sayt qancha vaqtda o'zini oqlaydi?",
            a: "Bu butunlay marjangizga bog'liq. O'rtacha cheki 6 mln so'm va marjasi 30% bo'lgan xizmat kompaniyasi uchun sayt plus olti oylik SEO odatda 8–14 oyda nolga chiqadi. O'rtacha cheki past biznesda esa qaytim savdo hajmi orqali keladi va boshqacha hisoblanadi. Universal muddat yo'q — o'z raqamingizni maqoladagi besh qadamli hisobga qo'yib ko'ring.",
        },
        {
            q: "Instagram yetarli emasmi, sayt shartmi?",
            a: "Ular bir-birini almashtirmaydi. Instagram — ijaraga olingan auditoriya: akkaunt bloklansa yoki algoritm o'zgarsa, kanal yo'qoladi. Sayt esa sizga tegishli aktiv va u qidiruvdan trafik oladi, ya'ni odam mahsulotingizni qidirganda sizni topadi. Korporativ mijozlar va tenderlar uchun ham sayt ko'pincha rasmiy talab hisoblanadi.",
        },
        {
            q: "Saytni o'zim boshqara olamanmi?",
            a: "Ha, agar loyihada admin panel bo'lsa. Unda matn, rasm, narx, xizmatlar va yangiliklarni dasturchisiz o'zgartirasiz. Vizitka va landing page'ning eng arzon tarifida adminka bo'lmaydi, lekin olti oylik qo'llab-quvvatlash davomida kichik o'zgarishlarni biz bepul kiritamiz. Admin panelni keyinroq qo'shish ham mumkin, uning narxi odatda 3 000 000 so'mdan boshlanadi.",
        },
        {
            q: "Sayt ochsam, arizalar o'zi kela boshlaydimi?",
            a: "Yo'q. Sayt ochilgan kuni uni hech kim bilmaydi. Arizalar ikki yo'l bilan keladi: kontekst reklama orqali — bu birinchi haftadanoq ishlaydi, va organik qidiruv orqali — bu 4–6 oy talab qiladi. Shuning uchun sayt byudjetini rejalashtirganda ishga tushirishdan keyingi olti oyga reklama yoki SEO mablag'ini ham ajrating.",
        },
        {
            q: "Qaysi holatda sayt yaratish tavsiya qilinmaydi?",
            a: "Mahsulotingiz hali tasdiqlanmagan bo'lsa, birinchi sotuvlarni qo'lda qiling — sayt gipotezani tekshirmaydi, u tasdiqlangan gipotezani kengaytiradi. Sotuvingiz bitta yopiq kanalga, masalan tender yoki yirik distribyutorga bog'langan bo'lsa, rekvizitlari bor oddiy vizitka sahifasi yetadi. Ishga tushirishdan keyin reklama byudjeti rejalashtirilmagan bo'lsa yoki kontent tayyorlashga odam ajratmasangiz ham, sayt kutilgan natijani bermaydi.",
        },
    ],

    cta: {
        h: "Sayt sizga kerakmi — bepul aniqlaymiz",
        p:
            "Biznesingiz, o'rtacha chekingiz va maqsadingizni eshitib, qaysi tur mos kelishini va taxminiy byudjetni aytamiz. Agar sayt sizga hozir kerak emas deb hisoblasak, buni ham ochiq aytamiz.",
        button: "Konsultatsiya olish",
    },

    images: [
        {
            src: "/assets/img/blog/web-cover.webp",
            alt: "Kompaniyaning veb-sayti noutbuk va smartfon ekranida ochilgan holda ko'rsatilgan",
            caption: "Sayt — biznesingizning raqamli manzili va sizga tegishli aktiv",
        },
        {
            src: "/assets/img/blog/web-process.webp",
            alt: "Sayt yaratish jarayoni bosqichlari: tahlil, dizayn, ishlab chiqish va ishga tushirish",
            caption: "Tashrifdan arizagacha bo'lgan yo'l — qaytim shu zanjirdan hisoblanadi",
        },
        {
            src: "/assets/img/blog/web-seo.webp",
            alt: "Qidiruv natijalarida saytning o'rni va organik trafik o'sishini ko'rsatuvchi grafik",
            caption: "Organik trafik 4–6 oydan keyin sezilarli bo'ladi, birinchi oydan emas",
        },
        {
            src: "/assets/img/blog/cleanza-arxitektura.webp",
            alt: "Sayt arxitekturasi sxemasi: frontend, admin panel va ariza oqimi o'zaro bog'langan",
            caption: "Saytning ichki tuzilishi: ko'rinadigan qism, admin panel va ariza oqimi",
        },
    ],

    relatedServices: ["korporativ-saytlar", "vizitka-saytlar", "seo"],
    relatedPosts: ["turlari", "internetdokon"],
};

const ru = {
    meta: {
        title: "Что такое сайт и кому он нужен — цена и окупаемость",
        description:
            "Что такое веб-сайт, из чего состоит и кому нужен. Цена сайта в Узбекистане 4–45 млн сум, расчёт окупаемости, цена бездействия и когда сайт не нужен.",
        keywords: [
            "веб-сайт",
            "что такое сайт",
            "создание сайта цена",
            "зачем нужен сайт",
            "сколько стоит сайт",
            "домен и хостинг",
            "корпоративный сайт",
        ],
    },
    h1: "Веб-сайт: что он даёт бизнесу, сколько стоит и когда окупается",
    lead:
        "Сайт — это не «пусть будет», а актив с понятной стоимостью и понятной отдачей. Разбираем на цифрах, из чего состоит сайт, сколько он стоит в Узбекистане и в каких случаях он вам не нужен вовсе.",
    category: "Веб-сайты",
    readingTime: "10 минут",

    body: [
        {
            type: "p",
            text:
                "Каждую неделю нам задают один и тот же вопрос: «Нужен ли сайт или хватит Instagram?» Честный ответ не всегда «да». Одному бизнесу сайт приносит деньги с первого месяца, другому остаётся украшением за 9 миллионов сум. Ниже — в чём именно разница.",
        },

        { type: "h2", text: "Что такое веб-сайт и из чего он состоит?" },
        {
            type: "p",
            text:
                "Веб-сайт — это набор связанных по смыслу страниц, принадлежащих одной организации или человеку. На странице может быть текст, изображение, видео, форма или калькулятор. Технически сайт — это файлы на подключённом к интернету сервере и программа, которая отдаёт их браузеру.",
        },
        {
            type: "p",
            text:
                "Для владельца бизнеса важнее другое: сайт состоит из трёх арендуемых частей и одной покупаемой. Арендуете вы домен, хостинг и SSL-сертификат. Покупаете — сам сайт, то есть дизайн и код.",
        },
        {
            type: "list",
            items: [
                "Домен — адрес сайта, например innobek.uz, где uz — доменная зона. Зона .uz существует с 1995 года, её ведёт UZINFOCOM, регистрация идёт через cctld.uz.",
                "Хостинг (сервер) — постоянно подключённый к интернету компьютер, где лежат файлы сайта. Там сайт и «живёт».",
                "SSL-сертификат — тот самый замочек в браузере. Без него Google помечает сайт как небезопасный, и посетитель не заполняет форму.",
                "Фронтенд — то, что видит пользователь: дизайн, тексты, кнопки, адаптация под мобильные устройства.",
                "Админ-панель — место, где вы меняете тексты, цены и картинки без программиста.",
            ],
        },
        { type: "image", image: 3 },
        {
            type: "p",
            text:
                "Стоит выпасть одному элементу — и сайт работает наполовину. Без админки к разработчику приходится обращаться из-за каждой запятой. Без мобильной адаптации сайта, считай, нет: с 2024 года Google индексирует все сайты по их мобильной версии.",
        },

        { type: "h2", text: "Есть же Instagram — зачем тогда сайт?" },
        {
            type: "p",
            text:
                "Честный ответ такой: соцсеть и сайт не заменяют друг друга, у них разные задачи. Instagram — арендованная аудитория. Заблокируют аккаунт или сменится алгоритм — и вы за ночь теряете канал, предъявить претензию некому.",
        },
        {
            type: "p",
            text:
                "Сайт — ваш собственный актив. Он получает трафик из поиска: человек ищет «складское оборудование в Ташкенте» и находит вас. В выдаче по такому запросу Instagram не появится. Плюс для корпоративного клиента сайт — критерий доверия: крупная компания не примет ссылку на профиль в соцсети как заявку на тендер.",
        },
        {
            type: "p",
            text:
                "С маркетплейсами похожая история: начать продавать на Uzum проще, но с каждой продажи уходит доля, а база клиентов остаётся у площадки. В нашей практике устойчивее всего работает связка: сайт как основа, соцсети как источник интереса, маркетплейс как дополнение.",
        },

        { type: "h2", text: "Что конкретно сайт даёт бизнесу?" },
        {
            type: "p",
            text:
                "Обойдёмся без общих слов и перечислим пять измеримых задач — с указанием, как каждую проверить. Пользу, которую нельзя измерить, считать бессмысленно.",
        },
        {
            type: "list",
            items: [
                "Приносит заявки из поиска. Измеряется в Google Analytics и по числу отправленных форм. Ключевой показатель — стоимость одной заявки.",
                "Экономит время отдела продаж. Если цены, условия доставки и характеристики есть на сайте, менеджер не отвечает на один и тот же вопрос по десять раз в день.",
                "Формирует доверие. Реквизиты, лицензии, выполненные работы и реальные отзывы снимают часть сомнений ещё до разговора.",
                "Удешевляет рекламу. Когда Google Ads и таргет ведут на правильно собранную страницу, конверсия растёт, а стоимость привлечения клиента падает.",
                "Упрощает внутреннюю работу. Документы, прайс, вакансии и отчёты лежат по одному адресу, и сотрудник получает к ним доступ из любой точки мира.",
            ],
        },
        {
            type: "p",
            text:
                "Ни один пункт из списка не срабатывает сам собой. В день запуска заявок не будет — сайт ещё должны найти. Поэтому дальше мы считаем стоимость не только разработки, но и запуска.",
        },

        { type: "h2", text: "Сколько стоит создание сайта?" },
        {
            type: "p",
            text:
                "Цена зависит от типа сайта, а не от числа страниц. В таблице — тарифы Innobek и средние сроки. Это стартовый диапазон: итоговая сумма подтверждается после бесплатной консультации и зависит от интеграций, объёма контента и языковых версий.",
        },
        {
            type: "table",
            head: ["Тип сайта", "Цена (сум)", "Срок", "Кому подходит"],
            rows: [
                ["Landing page", "от 4 000 000", "5–10 рабочих дней", "Один продукт, поток рекламы, быстрый тест"],
                ["Сайт-визитка", "от 5 000 000", "7–12 рабочих дней", "Малый бизнес, специалист, сфера услуг"],
                ["Корпоративный сайт", "от 9 000 000", "12–35 рабочих дней", "Производство, дистрибуция, сервисная компания"],
                ["Интернет-магазин", "от 16 000 000", "20–60 рабочих дней", "Продажа товаров онлайн, корзина и оплата"],
                ["Сложная платформа", "от 45 000 000", "по договорённости", "Личный кабинет, филиалы, интеграция с 1С"],
            ],
        },
        {
            type: "p",
            text:
                "Отдельно стоит сказать о том, что в цену не входит — именно здесь возникают незапланированные траты. Домен и хостинг оплачиваются провайдеру напрямую: для обычного сайта это примерно 400 000 – 1 200 000 сум в год, для нагруженного магазина 1,5–3 млн сум. Профессиональная съёмка, написание текстов и рекламный бюджет считаются отдельно.",
        },
        {
            type: "callout",
            text:
                "Практическое правило: закладывая бюджет на сайт, добавьте сверху ещё 30–50% на контент, съёмку и первые полгода продвижения. Ситуация «сайт есть, но его никто не видит» — самая частая ошибка.",
        },

        { type: "h2", text: "За какой срок сайт окупается?" },
        {
            type: "p",
            text:
                "Для расчёта нужны четыре числа: месячный трафик, конверсия в заявку, доля заявок, доходящих до договора, и ваша маржа в среднем чеке. Ниже расчёт на примере средней B2B-компании услуг — подставьте свои значения.",
        },
        { type: "image", image: 1 },
        {
            type: "ol",
            items: [
                "900 визитов в месяц — реальный показатель через полгода работы SEO и контекста.",
                "Конверсия сайта 3% — это 27 заявок. Для грамотно собранного сайта нормальный диапазон 2–4%.",
                "Из заявки в договор переходит 20% — 5 клиентов.",
                "Средний чек 6 000 000 сум при марже 30% — 1 800 000 сум чистыми с клиента.",
                "Чистая прибыль за месяц: 5 × 1 800 000 = 9 000 000 сум.",
            ],
        },
        {
            type: "p",
            text:
                "Теперь расходная часть. Корпоративный сайт — 9 млн сум, полгода SEO — от 6 млн сум в месяц, то есть около 45 млн сум за первый год. Трафик не появляется с нулевого месяца: первые три месяца заявок почти нет, дальше идёт рост. Поэтому честный ответ — такая модель обычно выходит в ноль за 8–14 месяцев, а прибыль даёт со второго года.",
        },
        {
            type: "p",
            text:
                "Если ваш средний чек 500 000 сум, тот же расчёт выглядит совершенно иначе: вам нужен объём заявок, а значит, сначала реклама и работа над конверсией, а не SEO. Поэтому мы никогда не обещаем универсальное «сайт окупится за три месяца» — эта цифра зависит от вашей маржи.",
        },

        { type: "h2", text: "Сколько стоит не делать ничего?" },
        {
            type: "p",
            text:
                "Бездействие тоже стоит денег, просто этот расход не виден в отчёте. Его можно прикинуть. Допустим, в вашей нише 400 человек в месяц ищут в Google подходящий запрос, и 4% из них обращаются — это 16 заявок. Сегодня все они уходят к конкурентам.",
        },
        {
            type: "p",
            text:
                "При той же марже (1 800 000 сум) и доле договоров в 20% это 3 клиента в месяц, то есть 5 400 000 сум неполученной прибыли. За год — больше 64 млн сум. На фоне этой цифры стоимость сайта выглядит скромно, но помните оговорку: трафик не приходит сам, его нужно заработать.",
        },
        {
            type: "p",
            text:
                "Второй скрытый расход — время. Если менеджер тратит по два часа в день на одни и те же вопросы, за месяц набегает 40 часов. Это почти рабочая неделя, и её возвращает нормально написанный раздел с ценами и условиями.",
        },

        { type: "h2", text: "Когда сайт вам не нужен?" },
        {
            type: "p",
            text:
                "Нам самим этот раздел невыгоден, но без него статья была бы нечестной. В перечисленных ниже случаях сайт — не лучшая инвестиция, и мы говорим об этом клиенту прямо.",
        },
        {
            type: "list",
            items: [
                "Продукт ещё не проверен. Сделайте первые 10 продаж вручную — через Telegram или соцсети. Сайт не проверяет гипотезу, он масштабирует уже проверенную.",
                "Все продажи идут по одному закрытому каналу. Если вы работаете через госзакупки или одного крупного дистрибьютора, достаточно простой страницы с реквизитами.",
                "После запуска нет бюджета на продвижение. Без денег на рекламу или SEO сайт простоит год, и на него никто не зайдёт.",
                "Нет контента и некому его готовить. Сайт из пустых текстов и стоковых фото не повышает доверие, а снижает его.",
                "Вам нужен не сайт, а внутренняя система. Если главная боль — учёт заказов, начните с CRM, сайт подождёт.",
            ],
        },
        {
            type: "p",
            text:
                "Назовём прямо и ещё один минус: сайт не даёт быстрого результата. Контекстная реклама приносит заявки за неделю, органический трафик требует 4–6 месяцев. Если результат нужен в этом месяце, направьте основную часть бюджета в рекламу, а сайт стройте как посадочную страницу под неё.",
        },

        { type: "h2", text: "Что происходит после запуска?" },
        {
            type: "p",
            text:
                "Сдача проекта — это начало, а не финал. В первый месяц сайт индексируется Google, подключаются Analytics и Search Console, проверяется, что заявки из форм доходят до Telegram или CRM. Только после этого начинают копиться реальные данные.",
        },
        { type: "image", image: 2 },
        {
            type: "list",
            items: [
                "Техническое сопровождение: доступность сайта, резервные копии, SSL и обновления.",
                "Скорость: LCP до 2,5 секунды, CLS ниже 0,1 — это официально опубликованные пороги Google Core Web Vitals.",
                "Контент: регулярное пополнение страниц услуг и статей, иначе рост останавливается.",
                "Аналитика: с каких страниц приходят заявки, а с каких люди уходят.",
            ],
        },
        {
            type: "p",
            text:
                "В Innobek шесть месяцев поддержки входят в стоимость сайта. Дальше при желании заключаем договор на обслуживание, можно обращаться и без него. Код и домен принадлежат вам — мы не удерживаем их у себя.",
        },

        { type: "h2", text: "С чего начать?" },
        {
            type: "ol",
            items: [
                "Сформулируйте одну задачу сайта: заявки, доверие или онлайн-продажи. Все три в одном бюджете размывают результат.",
                "Посчитайте средний чек и маржу — без этих чисел окупаемость не считается.",
                "Выберите тип сайта. Сомневаетесь — начните с меньшего: визитку можно позже дорастить до корпоративного сайта.",
                "Подготовьте контент заранее: услуги, цены, выполненные работы, фото команды.",
                "Заложите бюджет на продвижение на первые полгода после запуска.",
            ],
        },
        {
            type: "quote",
            text:
                "Сайт не отвечает на вопрос — он приводит человека, который его задаёт. Всё остальное зависит от вашего отдела продаж.",
        },
    ],

    faq: [
        {
            q: "Сколько стоит создание сайта в Узбекистане?",
            a: "В Innobek landing page начинается от 4 000 000 сум, сайт-визитка от 5 000 000 сум, корпоративный сайт от 9 000 000 сум, интернет-магазин от 16 000 000 сум. Если нужны личный кабинет, система филиалов или интеграция с 1С, цена обычно превышает 45 млн сум. Итоговая сумма подтверждается после бесплатной консультации и зависит от числа страниц, интеграций и языковых версий.",
        },
        {
            q: "Сколько в год уходит на домен и хостинг?",
            a: "Для обычной визитки или корпоративного сайта домен и хостинг вместе стоят примерно 400 000 – 1 200 000 сум в год. Для нагруженного интернет-магазина сумма доходит до 1,5–3 млн сум. Оплата идёт провайдеру напрямую и в стоимость разработки не входит. Домен оформляется на вас — мы не оставляем его у себя.",
        },
        {
            q: "За какой срок сайт окупается?",
            a: "Всё зависит от вашей маржи. Для компании услуг со средним чеком 6 млн сум и маржой 30% сайт плюс полгода SEO обычно выходят в ноль за 8–14 месяцев. В бизнесе с низким средним чеком окупаемость приходит через объём продаж и считается иначе. Универсального срока нет — подставьте свои числа в пятишаговый расчёт из статьи.",
        },
        {
            q: "Разве недостаточно Instagram — обязательно ли делать сайт?",
            a: "Они не заменяют друг друга. Instagram — арендованная аудитория: блокировка аккаунта или смена алгоритма лишает вас канала. Сайт же принадлежит вам и получает трафик из поиска, то есть находит человека в момент, когда он ищет ваш продукт. Для корпоративных клиентов и тендеров сайт часто ещё и формальное требование.",
        },
        {
            q: "Смогу ли я управлять сайтом самостоятельно?",
            a: "Да, если в проекте есть админ-панель. Тексты, изображения, цены, услуги и новости вы меняете без программиста. В самом бюджетном тарифе визитки и landing page админки нет, но в течение шести месяцев поддержки мелкие правки мы вносим бесплатно. Админку можно добавить и позже — обычно это от 3 000 000 сум.",
        },
        {
            q: "Если я запущу сайт, заявки пойдут сами?",
            a: "Нет. В день запуска о сайте не знает никто. Заявки приходят двумя путями: через контекстную рекламу — она работает уже с первой недели, и через органический поиск — на это нужно 4–6 месяцев. Поэтому, планируя бюджет на сайт, заложите деньги на рекламу или SEO на первые полгода после запуска.",
        },
        {
            q: "В каких случаях сайт делать не стоит?",
            a: "Если продукт ещё не проверен — сделайте первые продажи вручную, сайт не тестирует гипотезу. Если продажи идут по одному закрытому каналу, хватит простой страницы с реквизитами. Если после запуска не запланирован бюджет на продвижение или некому готовить контент, сайт тоже не даст ожидаемого результата.",
        },
    ],

    cta: {
        h: "Бесплатно разберёмся, нужен ли вам сайт",
        p:
            "Разберём задачу, средний чек и цель, назовём подходящий тип сайта и примерный бюджет. Если решим, что сайт вам сейчас не нужен, скажем об этом прямо.",
        button: "Получить консультацию",
    },

    images: [
        {
            src: "/assets/img/blog/web-cover.webp",
            alt: "Корпоративный сайт компании открыт на экране ноутбука и смартфона одновременно",
            caption: "Сайт — цифровой адрес бизнеса и актив, который принадлежит вам",
        },
        {
            src: "/assets/img/blog/web-process.webp",
            alt: "Этапы создания сайта: анализ, дизайн, разработка и запуск проекта",
            caption: "Путь от визита до заявки — именно по нему считается окупаемость",
        },
        {
            src: "/assets/img/blog/web-seo.webp",
            alt: "График роста органического трафика и позиций сайта в результатах поиска",
            caption: "Органический трафик заметен через 4–6 месяцев, а не с первого месяца",
        },
        {
            src: "/assets/img/blog/cleanza-arxitektura.webp",
            alt: "Схема архитектуры сайта: фронтенд, админ-панель и поток заявок связаны между собой",
            caption: "Внутреннее устройство сайта: видимая часть, админка и поток заявок",
        },
    ],

    relatedServices: ["korporativ-saytlar", "vizitka-saytlar", "seo"],
    relatedPosts: ["turlari", "internetdokon"],
};

const content = { uz, ru };

export default content;
